// eslint-disable-next-line import/prefer-default-export
export const authConfig = {
  clientId: process.env.VUE_APP_CLIENT_ID,
  tenantId: process.env.VUE_APP_TENANT_ID,
  redirectUri: process.env.VUE_APP_REDIRECT_URL,
  authEndpoint: `https://login.microsoftonline.com/${process.env.VUE_APP_TENANT_ID}/oauth2/v2.0/authorize`,
  scopes: 'openid profile email',
};
